/*@ngInject*/
export default () => (items, find) => {
    return items.filter((item) => {
        return !find ? true : item.name.toLowerCase().match(find.toLowerCase()) || item.dialCode.match(find);
    });
}